import React, { useState } from "react";
import styles from "./ShareReferralCode.module.scss";
import { Button, HStack, IconButton, Stack, VStack } from "rsuite";
import SearchIcon from "@rsuite/icons/Search";
import { MdOutlineContentCopy } from "react-icons/md";
import { Link } from "react-router-dom";
import GearIcon from "@rsuite/icons/Gear";
import { GoShareAndroid } from "react-icons/go";
import { IoGift } from "react-icons/io5";
import { TbCopyCheckFilled } from "react-icons/tb";

export default function ShareReferralCode() {
  const [copied, setCopied] = useState(false);

  const textToCopy = "Hello, this is referrel code!";

  const handleCopy = () => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(textToCopy)
        .then(() => {
          setCopied(true);

          setTimeout(() => setCopied(false), 2000);
        })
        .catch((error) => console.log("Failed to copy text:", error));
    } else {
      fallbackCopyTextToClipboard(textToCopy);
    }
  };

  const fallbackCopyTextToClipboard = (text) => {
    const textArea = document.createElement("textarea");
    textArea.value = text;

    // Make textarea out of viewport
    textArea.style.position = "fixed";
    textArea.style.left = "-9999px";
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand("copy");
      if (successful) {
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
      } else {
        console.error("Fallback: Unable to copy");
      }
    } catch (err) {
      console.error("Fallback: Error copying text", err);
    }

    document.body.removeChild(textArea);
  };

  return (
    <div className={styles["share__referral-code"]}>
      <VStack alignItems="stretch" spacing={30}>
        <div className={styles.content}>
          <img src="/images/refer.png" alt="" />
          <h2>Refer and Earn</h2>
          <p>Earn 3% for Every Successful Referral!</p>
        </div>

        <HStack justifyContent="space-between" alignItems="center">
          <HStack onClick={() => handleCopy()}>
            <span className={styles.referText}>Referral code</span>
            {copied ? <TbCopyCheckFilled size={20} color="#4caf50" /> : <MdOutlineContentCopy size={16} />}
          </HStack>
          <Button color="green" appearance="primary" startIcon={<GoShareAndroid />}>
            Share Referral Code
          </Button>
        </HStack>

        <HStack alignItems="flex-start" justifyContent="space-between" spacing={10}>
          <div>
            <IoGift size={30} color="#182bda" />
          </div>
          <div>
            Invite your friends to join and get 3% every time they successfully take a loan. The more friends you refer,
            the more you earn!
          </div>
        </HStack>

        <HStack alignItems="flex-start" justifyContent="space-between" spacing={10}>
          <div>
            <IoGift size={30} color="#182bda" />
          </div>
          <div>Share your referral code or invite friends directly via WhatsApp to start earning today.</div>
        </HStack>
      </VStack>
    </div>
  );
}
